import {
  MdEventAvailable,
  MdOutlineAssignment,
  MdOutlineCameraAlt,
  MdOutlineLock,
  MdOutlineSecurity,
  MdSettingsSuggest,
} from "react-icons/md";
import { companyInfo, industries, services } from "./RunzeweContent";

const serviceIcons = [
  <MdOutlineSecurity />,
  <MdOutlineLock />,
  <MdOutlineCameraAlt />,
  <MdEventAvailable />,
  <MdOutlineAssignment />,
  <MdSettingsSuggest />,
];

export default function ServicesContent() {
  return (
    <>
      <section className="page-hero services-page-hero">
        <div className="page-hero-overlay" />
        <div className="container page-hero-content" data-aos="fade-up">
          <p className="section-kicker">Our Services</p>
          <h1>Security Services Built Around Real Risk.</h1>
          <p>
            From guarding and mobile patrols to CCTV, access control, risk
            assessment, and event security, Runzewe provides protection that
            adapts to each client's site.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="section-heading" data-aos="fade-up">
            <p className="section-kicker">Service Portfolio</p>
            <h2>Integrated protection for people, premises, and operations.</h2>
          </div>

          <div className="service-detail-grid">
            {services.map((service, index) => (
              <article className="service-detail-card" key={service.title} data-aos="fade-up" data-aos-delay={(index % 3) * 70}>
                <div className="service-detail-icon">{serviceIcons[index]}</div>
                <h3>{service.title}</h3>
                <p>{service.details}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="content-section section-soft">
        <div className="container">
          <div className="split-grid">
            <div data-aos="fade-right">
              <p className="section-kicker">24-Hour Control</p>
              <h2>Technology-backed security that never sleeps.</h2>
              <p>
                Runzewe supports manned guarding with electronic security
                equipment, CCTV surveillance, access control, technical
                maintenance, and monitoring processes designed for early
                detection and fast response.
              </p>
              <div className="feature-list">
                <span>CCTV and control room monitoring</span>
                <span>Biometric and card access systems</span>
                <span>Installation and maintenance support</span>
                <span>Risk mapping and incident reporting</span>
              </div>
            </div>

            <div className="image-panel" data-aos="fade-left">
              <img src={companyInfo.controlRoomImage} alt="Runzewe security monitoring room" />
            </div>
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="section-heading" data-aos="fade-up">
            <p className="section-kicker">Industries We Protect</p>
            <h2>Security for high-traffic, high-value, and high-care spaces.</h2>
          </div>

          <div className="industry-grid industry-grid-large">
            {industries.map((industry, index) => (
              <div className="industry-card" key={industry.title} data-aos="zoom-in" data-aos-delay={(index % 3) * 70}>
                <img src={industry.image} alt={industry.title} />
                <h3>{industry.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
